var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPension(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 34,
    viewBox: "0 0 25 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9494ED",
    d: "M23.34 19.57h-1.244c-.276-4.14-2.99-7.612-6.72-8.99-.069.268-.31.468-.602.468H8.82c-.29 0-.533-.2-.601-.47-1.056.392-2.032.949-2.894 1.644l-.727-.728c-.243-.243-.637-.243-.88 0-.242.243-.242.637 0 .879l.687.687c-1.283 1.316-2.216 2.973-2.653 4.823H0v4.76h1.752c.509 2.154 1.691 4.047 3.314 5.444l-.996 2.616 4.45 1.694.803-2.11c.793.195 1.621.3 2.474.3 1.171 0 2.295-.198 3.344-.557l.901 2.367 4.45-1.694-1.253-3.288c1.665-1.733 2.733-4.043 2.868-6.602h1.233c.343 0 .622-.278.622-.622s-.279-.622-.622-.622M5.397 18.4c-.619 0-1.121-.502-1.121-1.121 0-.62.502-1.122 1.121-1.122.62 0 1.123.502 1.123 1.122 0 .619-.503 1.121-1.123 1.121",
    transform: "translate(.506 .708)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3C2F0",
    d: "M15.093 3.103c0 1.715-1.39 3.103-3.103 3.103-1.715 0-3.104-1.388-3.104-3.103C8.886 1.39 10.276 0 11.99 0c1.713 0 3.103 1.39 3.103 3.103",
    transform: "translate(.506 .708)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPension);
export default __webpack_public_path__ + "static/media/pension.333179359ead8f8f4c001d0d8c60d2c6.svg";
export { ForwardRef as ReactComponent };